import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  @media (max-width: ${tokens.breakpoints.m}) {
    padding: 0 ${tokens.space.regular};
  }
`;
